/**
 * 상세화면 함수
 */


import { update_detail_shop_memo } from "../http/DetailConn";
import { select_addr_forkakao_detail_check } from "../http/kakaoConn";
import { select_addr_fornaver_detail_check } from "http/addrConn"
import { select_access_token } from "../http/TokenConn";
import { fn_bridge_order_cancel, fn_bridge_log } from "./FnPosBridge";
import { send_vo_cs } from "http/DetailConn"
import AddressSearchView from "../views/main/body/layer/AddressSearchView";
import { analyticeEvent, aesDecoding } from "utils/Utils"
import { fn_select_quick_addr } from "function/FnBodySetting"
import { fn_end_order_change_step } from "function/FnBodyStep"
import { api_end_order_list_paging } from "http/EndOrderConn"

// 주문 상세보기 레이어 열기
export function fn_orderDetail(rootStore, mobileOrderNo, type) {
    //card list style 처리
    rootStore.orderStore.changeOrderListStyle(mobileOrderNo);
    fn_removeOrderNew(rootStore, mobileOrderNo);
    let status = rootStore.viewStore.getStatusOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo)
    if (status) {
        rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);
        fn_setOrderDetail(rootStore, mobileOrderNo, type).then(r => {
            rootStore.viewStore.initOrderSoldOutProd();     // 품절초기화
            if (Array.isArray(rootStore.viewStore.getOrderDetail.viewProds)) {
                for (const prod of rootStore.viewStore.getOrderDetail.viewProds) {
                    rootStore.viewStore.addOrderSoldOutProd(prod);
                }
            }
            if (rootStore.viewStore.getOrderDetail.orderType === "DELIVERY") {
                rootStore.viewStore.setDetailSearchAddr(rootStore.viewStore.getOrderDetail.dlvAddr);
                //select_addr_forkakao_detail_check(rootStore).then(r => {
                select_addr_fornaver_detail_check(rootStore, "detail").then(r => {
                    rootStore.viewStore.setDetailLayer();
                });
            } else {
                rootStore.viewStore.setDetailLayer();
            }

        });
    }
}

// 지난 주문 상세보기 레이어 열기
export function fn_orderEndDetail(rootStore, mobileOrderNo, type) {
    //card list style 처리
    rootStore.viewStore.setEndOrderViewType(type)
    rootStore.orderStore.changeOrderListStyle(mobileOrderNo);
    fn_removeOrderNew(rootStore, mobileOrderNo);
    fn_setOrderDetail(rootStore, mobileOrderNo, type).then(r => {
        rootStore.viewStore.setDetailEndLayer();

    });
}

// 상세객체 셋팅
export async function fn_setOrderDetail(rootStore, mobileOrderNo, type) {

    let response;
    if (type === "order") {
        response = await rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);
    } else if (type === "endOrderView") {
        //완료주문view상세
        response = await rootStore.viewStore.setOrderDetail(rootStore.endOrderStore.getEndOrderCompleteList, mobileOrderNo);
    } else if (type === "endOrder") {
        //지난주문내역 상세
        response = await rootStore.viewStore.setOrderDetail(rootStore.endOrderStore.getEndOrderList, mobileOrderNo);
    }

    return response;
}

// 지난 주문 상세보기 레이어 열기
export function fn_orderEndDetailView(rootStore, mobileOrderNo) {
    api_end_order_list_paging(rootStore, mobileOrderNo).then(res => {
        if(res){
            fn_orderEndDetail(rootStore, mobileOrderNo, "endOrder")
        }
    });
}

// 상세보기 레이어 닫기
export function fn_closeDetailView(rootStore) {
    // 선택된 주소 정보 제거
    rootStore.viewStore.initSelectedAddr();
    rootStore.viewStore.setDetailClose();
    rootStore.layerStore.setLayerDeliveryCall(false);
    rootStore.layerStore.setLayerBaeminEndOrderView(false);
}

// 메모 레이어 열기
export function fn_orderDetailMemo(rootStore) {
    fn_setOriShopMemo(rootStore);
    rootStore.viewStore.setDetailMemoLayer();
}

// 메모 레이어 닫기
export function fn_closeDetailMemoView(rootStore) {
    rootStore.viewStore.setDetailMemoClose();
    rootStore.viewStore.setBackShopMemo(rootStore.viewStore.getOriShopMemo);
}

// 메모 값 객체 수정
export function fn_updateDetailMemo(rootStore, value) {
    rootStore.viewStore.setChangeViewObj('shopMemo', value);
}

// 메모 값 DB 수정
export function fn_updateDetailMemoApi(rootStore) {
    select_access_token(rootStore).then(res => {
        rootStore.orderStore.addListByViewObj(rootStore.viewStore.getOrderDetail);
        rootStore.endOrderStore.addListByViewObj(rootStore.viewStore.getOrderDetail);
        update_detail_shop_memo(rootStore);
        rootStore.viewStore.setDetailMemoClose();
    });
}

// 메모 값 초기값 저장
export function fn_setOriShopMemo(rootStore) {
    rootStore.viewStore.setOriShopMemo(rootStore.viewStore.getOrderDetail.shopMemo);
}

// 주문 품절상품 연결메뉴 열고 닫기
export function fn_setOrderSoldOutProdCode(rootStore, prodCode) {
    if (rootStore.viewStore.getOrderSoldOutConn === prodCode) {
        rootStore.viewStore.setOrderSoldOutConn("");
    } else {
        rootStore.viewStore.setOrderSoldOutConn(prodCode);
    }
}

// 거절 및 취소
export function fn_quick_cancel(rootStore) {
    let data = rootStore.viewStore.getOrderDetail;
    if(rootStore.layerStore.getChangeCancelReason == ""){
        rootStore.layerStore.setLayerAlertType("changeCancelReason");
        rootStore.layerStore.setLayerAlertView(true);
    }else {
        if(data.stepCd ==  "700" && data.mobileOrderFg == "27"){
            fn_end_order_change_step(rootStore, '900');
        }else{
            fn_bridge_order_cancel(rootStore);
        }    
    }
}

// 주소 수정 호출
export function fn_change_addr(rootStore) {
    fn_select_quick_addr(rootStore);
    analyticeEvent("orderAddressEdit", "orderAddressEdit Button", rootStore.searchStore.getShopCd) //GA4
    rootStore.viewStore.setAddrBoxShowFlag(false);
    rootStore.viewStore.initSearchAddrList();       // 목록 초기화
    //rootStore.viewStore.initSelectedAddr();

    rootStore.viewStore.setDetailSearchAddrDetail("");  // 주소 상세 검색란 초기화
    rootStore.viewStore.setKakaoMap("", ""); // 지도 초기화

    rootStore.layerStore.setLayerAddressSearch(true);

    rootStore.Ad

}

// 고객 시간 알림 팝업 체크박스 위치 얻기
export function fn_get_customer_pop(rootStore, key) {
    let obj;
    obj = rootStore.viewStore.getCustomerPopBtn;
    return obj[key];
}

// 요기요 고객 시간 알림 팝업 체크박스 위치 얻기
export function fn_get_customer_ygy_pop(rootStore, key) {
    let obj;
    obj = rootStore.viewStore.getCustomerPopBtnYgy;
    return obj[key];
}

// 고객 시간 알림 팝업 체크박스 위치 수정
export function fn_set_customer_pop(rootStore, key) {
    rootStore.viewStore.setCustomerPopBtn(key, "Y");
}

// 요기요 고객 시간 알림 팝업 체크박스 위치 수정
export function fn_set_customer_ygy_pop(rootStore, key) {
    rootStore.viewStore.setCustomerPopBtnYgy(key, "Y");
}


// 객체 제거 일괄
export function fn_removeOrderNew(rootStore, mobileOrderNo) {
    let type = rootStore.searchStore.getCurrStepType;

    rootStore.orderStore.removeOrderNew(mobileOrderNo);     // 주문에서 new 체크 부분 삭제
    rootStore.rabbitMqStore.removeRabbitReadyNew(mobileOrderNo);                // 추가 주문 객체에서 선택항목 제거
    rootStore.rabbitMqStore.removeRabbitCookingNew(mobileOrderNo);                // 추가 주문 객체에서 선택항목 제거
    rootStore.rabbitMqStore.removeRabbitDeliveryNew(mobileOrderNo);                // 추가 주문 객체에서 선택항목 제거
}

export function fn_posOrderLayer(rootStore, mobileOrderNo) {
    fn_orderDetail(rootStore, mobileOrderNo, "order")
}

// 문의하기 값
export function fn_vocsDetail(rootStore, value, key) {
    rootStore.viewStore.setVocsDetail(key, value);
}

export function fn_setAgreeFlag(rootStore, viewBl) {
    rootStore.viewStore.setVocsAgreeDetail(viewBl)

}

export function fn_getAgreeFlag(rootStore) {
    return rootStore.viewStore.getVocsAgreeDetail;
}

export function fn_vocsRequierd(rootStore) {
    let type = rootStore.viewStore.getVocsTypeKeyVal.code
    let msg = rootStore.viewStore.getVocsDetail.vocMsg
    let tel = rootStore.viewStore.getVocsDetail.hpTelNo
    let maxByte = 500;
    const phoneNumberCheck = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?([0-9]{3,4})-?([0-9]{4})$/;
    if(type == ""){
        rootStore.viewStore.setVocsDetail("val", "문의유형을 입력해주세요")
    } else if (msg == "") {
        rootStore.viewStore.setVocsDetail("val", "문의내용을 입력해주세요")
        return false
    } else if (msg.length > maxByte) {
        rootStore.viewStore.setVocsDetail("val", "한글 최대 500자까지만 입력가능합니다")
        return false
    } else if (tel == "") {
        rootStore.viewStore.setVocsDetail("val", "연락처를 입력해주세요")
        return false
    } else if (!tel.match(phoneNumberCheck)) {
        rootStore.viewStore.setVocsDetail("val", "연락처를 다시 확인해주세요")
        return false;
    } else if (rootStore.viewStore.getVocsAgreeDetail == false) {
        rootStore.viewStore.setVocsDetail("val", "개인정보 수집 및 이용 안내에 동의해주세요")
        return false
    } else {
        rootStore.viewStore.setVocsDetail("val", "")
        analyticeEvent("button Click", "voCs button", "button")
        send_vo_cs(rootStore)
        fn_bridge_log(rootStore, false)
    }

}

export function fn_loginRequierd(rootStore, id, pw) {
    let info = rootStore.settingStore.getLoginInfo;
    let cntId = 0;
    let cntPw = 0;
    
    info.forEach((item, index) => {
        (item.id == id) ? cntId++ : ""
    });

    info.forEach((item, index) => {
        (aesDecoding(item.password) == pw) ? cntPw++ : ""
    });

    rootStore.layerStore.setManagerAuthView("auth", "N")

    if (id == "" || id == null) {
        rootStore.viewStore.setLoginAuthDetail("관리자(점주) 권한으로 로그인 해주세요")
        return false
    } else if (pw == "" || pw == null) {
        rootStore.viewStore.setLoginAuthDetail("비밀번호를 입력해주세요")
        return false
    } else if (cntId == 0) {
        rootStore.viewStore.setLoginAuthDetail("관리자(점주)권한으로 로그인 해주세요")
        return false
    } else if (cntPw == 0) {
        rootStore.viewStore.setLoginAuthDetail("비밀번호가 일치하지 않습니다")
        return false
    } else {
        if (cntId != 0 && cntPw != 0) {
            rootStore.layerStore.setManagerAuthView("auth", "Y")
            rootStore.layerStore.setLayerAuthView(false);
        }
    }

}

// 문의유형 레이어 열고 닫기
export function fn_setCsType(rootStore, value) {
    //fn_initSearchView(rootStore);
    rootStore.viewStore.setLayerVocsTypeView(value);
}

// 검색 레이어 조회 ( 검색어, 디테일 )
export function fn_getCsType(rootStore) {
    return rootStore.viewStore.getLayerVocsTypeView;
}

// 문의유형 키값 조회
export function fn_setCsTypeKey(rootStore, code, val) {
    rootStore.viewStore.setVocsTypeKeyVal("code", code);
    rootStore.viewStore.setVocsTypeKeyVal("val", val);
}

// 문의유형 키값 조회
export function fn_getCsTypeKey(rootStore) {
    return rootStore.viewStore.getVocsTypeKeyVal;
}
